import { siteApiSlice } from "../../../../app/siteApiSlice";

export interface MonthlyScoreViewModel {
	calendarYear: number;
	schoolYear: number;
	month: number;
	firstDraftScore?: number;
	lastDraftScore?: number;
}

export interface GetMonthlyAverageScoresRequestModel {
	beginSchoolYear: number;
	endSchoolYear: number;
	districtId?: number;
	schoolId?: number;
	courseId?: number;
	writerId?: number;
	genreId?: number;
	scoreCategoryId: number;
}

export const progressReportApiSlice = siteApiSlice.injectEndpoints({
	endpoints: (build) => ({
		getMonthlyAverageScores: build.query<
			MonthlyScoreViewModel[],
			GetMonthlyAverageScoresRequestModel
		>({
			query: (payload) => ({
				url: `/Report/GetMonthlyAverageScores`,
				method: "POST",
				body: payload,
				formData: true,
			}),
			providesTags: ["WritingHistory", "CurrentCourse"],
		}),
	}),
});

export const { useLazyGetMonthlyAverageScoresQuery } = progressReportApiSlice;
